// Huisstijl (build 2.2): één lettertype (Archivo) voor koppen en tekst. BF is het
// "display"-gewicht, FF de broodtekst — beide verwijzen naar hetzelfde font.
export const BF = "'Archivo',system-ui,sans-serif";
export const FF = "'Archivo',system-ui,sans-serif";

// Basiskleuren van de nieuwe stijl.
export const T = {
  bg: "#F5F3EE",      // warme achtergrond
  card: "#FFFFFF",
  soft: "#FAF8F4",    // zachte vlakken binnen een kaart
  line: "#E2DED5",    // scheidingslijnen
  line2: "#E6E2D9",   // kaartranden
  seg: "#E7E3DA",     // achtergrond schakelaar
  ink: "#1C1B19",     // hoofdtekst
  muted: "#6B675F",   // secundaire tekst
  primary: "#1A2744", // knoppen
};

// Niveaukleuren. `color` = volle kleur, `on` = tekstkleur óp die volle kleur,
// `ink` = leesbare tekstkleur op wit, `bg`/`border` = lichte varianten.
export const COLORS = [
  { color: "#B83232", on: "#FFFFFF", ink: "#B83232", bg: "#FBEDEC", border: "#F0C4C1" },
  { color: "#B85A12", on: "#FFFFFF", ink: "#B85A12", bg: "#FDF1E7", border: "#F3CDAE" },
  { color: "#2F7D47", on: "#FFFFFF", ink: "#2F7D47", bg: "#EDF6EF", border: "#BCDDC6" },
  { color: "#E8C12E", on: "#2A2205", ink: "#7A5C00", bg: "#FCF6DC", border: "#F1DC85" },
  { color: "#2A4E78", on: "#FFFFFF", ink: "#2A4E78", bg: "#EAF0F7", border: "#B9CBE0" },
  { color: "#B83A7A", on: "#FFFFFF", ink: "#B83A7A", bg: "#FBEDF4", border: "#EFC0D7" },
  { color: "#1D7F8C", on: "#FFFFFF", ink: "#1D7F8C", bg: "#E8F5F6", border: "#AED9DE" },
  { color: "#6A4BB0", on: "#FFFFFF", ink: "#6A4BB0", bg: "#F2EEFA", border: "#CFC2EA" },
  { color: "#3D4550", on: "#FFFFFF", ink: "#3D4550", bg: "#F0F1F3", border: "#C6CAD1" },
  { color: "#9A6A1A", on: "#FFFFFF", ink: "#8A5E14", bg: "#F8F0E2", border: "#E3CB9C" },
];

// Kleuren van vóór build 2.2 (zoals ze nog in de opgeslagen niveaus staan). Bij het
// laden worden ze omgezet naar de nieuwe tint op dezelfde positie.
const OLD_COLORS = ["#E53E3E", "#DD6B20", "#38A169", "#D69E2E", "#5A67D8", "#D53F8C", "#00B5D8", "#805AD5", "#2D3748", "#B7791F"];

function lum(hex) {
  var h = (hex || "#000000").replace("#", "");
  if (h.length === 3) h = h.split("").map(function (c) { return c + c; }).join("");
  var n = parseInt(h, 16);
  var rgb = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
  return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
}

// Zet een (oud of nieuw) niveau om naar de nieuwe kleurset, en vult `on`/`ink` aan
// voor kleuren die niet in de lijst staan.
export function restyleLevel(l) {
  if (!l || !l.color) return l;
  var up = l.color.toUpperCase();
  var idx = OLD_COLORS.indexOf(up);
  if (idx < 0) idx = COLORS.findIndex(function (c) { return c.color === up; });
  if (idx >= 0) return Object.assign({}, l, COLORS[idx]);
  var light = lum(l.color) > 0.45;
  return Object.assign({}, l, { on: l.on || (light ? "#2A2205" : "#FFFFFF"), ink: l.ink || (light ? "#5A4A00" : l.color) });
}

export const INIT_LEVELS = [
  { id: "rood", label: "Rood", ...COLORS[0], type: "plan" },
  { id: "oranje", label: "Oranje", ...COLORS[1], type: "plan" },
  { id: "groen", label: "Groen", ...COLORS[2], type: "plan" },
  { id: "geel", label: "Geel", ...COLORS[3], type: "plan" },
  { id: "volwassenen", label: "Volwassenen", ...COLORS[4], type: "plan" },
];

export const ETYPES = [
  { key: "warmup", icon: "W", bg: "#1D7F8C", label: "Warming-up" },
  { key: "exercise1", icon: "1", bg: "#C4552F", label: "Oefening 1" },
  { key: "exercise2", icon: "2", bg: "#C4552F", label: "Oefening 2" },
  { key: "match", icon: "⚡", bg: "#1A2744", label: "Wedstrijdvorm" },
];

export const MINUTE_PRESETS = [5, 10, 15, 20];

// "Extra oefeningen": per club één vaste sectie met eigen oefeningen, beheerd door de
// hoofdtrainer(s). Opgeslagen in clubs/{clubId}/config/extraDrills. In de app gedraagt
// het zich als een oefeningen-sectie met dit vaste id.
export const EXTRA_ID = "__extra";
export const EXTRA_LEVEL = { id: EXTRA_ID, label: "Extra oefeningen", ...COLORS[6], type: "drills", extra: true };
